import { CustomError, HttpError } from '@pressreader/types';

/**
 * The label this layer puts on a failure whose body it could not read as the project error
 * contract — a gateway's HTML page, an empty 404, a timeout. It is the transport's word, never the
 * backend's, so a caller deciding whether a failure carries a reason must not take it for one.
 */
export const UNPARSED_ERROR_MESSAGE = 'Unknown error';

export type IFetchErrorJson = {
    Message: string;
    message?: string;
    ResourceKey: string | null;
    resourceKey?: string;
};

export interface IFetchError extends Error {
    status: number;
    statusText: string;
    json: Promise<IFetchErrorJson>;
}

export class FetchError extends CustomError implements IFetchError {
    public status: number;
    public statusText: string;
    public json: Promise<IFetchErrorJson>;

    constructor(status: number, statusText: string, json: Promise<IFetchErrorJson>) {
        super(statusText);

        this.status = status;
        this.statusText = statusText;
        this.json = json;
    }

    async getHttpError() {
        let json: IFetchErrorJson = { Message: UNPARSED_ERROR_MESSAGE, ResourceKey: null };

        try {
            json = await this.json;
        } catch {
            // ignore
        }

        let responseJSON: HttpError['responseJSON'];
        if (json && typeof json === 'string') {
            responseJSON = { message: json, resourceKey: '' };
        } else {
            const { Message, message, ResourceKey, resourceKey, ...rest } = json;
            responseJSON = { ...rest, message: message ?? Message, resourceKey: resourceKey ?? ResourceKey ?? '' };
        }

        return new HttpError({
            status: this.status,
            responseText: this.statusText,
            responseJSON,
        });
    }
}
